import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AngularTokenService } from '@raysuelzer/angular-token';
import { Observable, of as observableOf } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export interface IEditPasswordParams {
  token: string;
}

@Injectable({ providedIn: 'root' })
export class PasswordResetResolver  {

  constructor(private authService: AngularTokenService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IEditPasswordParams> {
    const token = route.queryParamMap.get('reset_password_token');

    const resultObservable = observableOf({
      token
    });

    if (this.authService.userSignedIn()) {
      return this.authService.signOut().pipe(
        switchMap(() => resultObservable)
      );
    }

    return resultObservable;
  }
}
